import React from "react";
import { useNavigate } from "react-router-dom";

import { useQuery } from "react-query";
import useAxios from "../utils/useAxios";
import IP from "../variable";
import { formatTime } from "../utils/formatTime";

const CompanyMeetings = () => {
    const navigate = useNavigate();

    const api = useAxios();

    const { isLoading, data } = useQuery(
        "all-meetings",
        async () => api.get(`${IP}/company/meetings`),
        { cacheTime: 0 }
    );

    const slots = data?.data?.meetings ?? [];

    const availableSlots = slots.filter((slot) => !slot.is_blocked);

    return (
        <>
            <div className="table-header">
                Meeting Slots
            </div>

            {isLoading ? (
    <div className="placeholder-wave">
        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
    </div>
) : availableSlots.length > 0 ? (
    availableSlots.map((slot, index) => {
        const prev = availableSlots[index - 1];

        const isNewDay =
            index === 0 || prev.day !== slot.day;

        const isAfterLunch =
            !isNewDay &&
            prev.end_time <= "12:00:00" &&
            slot.start_time >= "13:00:00";

        return (
            <React.Fragment key={slot.id}>
                {isNewDay && (
                    <div className="day-header">
                        Day {slot.day}
                    </div>
                )}

                {isAfterLunch && (
                    <div className="lunch-break">
                        <div>
                            Prayer Break &
                            Networking Lunch
                        </div>

                        <span className="highlight">
                            {formatTime("12:00:00")} -{" "}
                            {formatTime("13:00:00")}
                        </span>
                    </div>
                )}

                <div className="custom-card">
                    <div className="d-flex flex-column">
                        <span>{slot?.name}</span>

                        <span
                            className="highlight"
                            style={{ fontSize: "0.7rem" }}
                        >
                            {formatTime(slot?.start_time)} -{" "}
                            {formatTime(slot?.end_time)}
                        </span>
                    </div>

                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <p
                                style={{
                                    marginBottom: 0,
                                    fontSize: "1.5rem",
                                    marginRight: "5px",
                                }}
                            >
                                {slot?.registration_count}/
                                {slot?.participants ?? 4}
                            </p>

                            <p
                                style={{
                                    fontSize: "0.7rem",
                                    marginBottom: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <span>
                                    {slot.registration_count > 1
                                        ? "Investors"
                                        : "Investor"}
                                </span>

                                <span style={{ marginTop: "-5px" }}>
                                    Registered
                                </span>
                            </p>
                        </div>

                        <button
                            type="button"
                            className="view-investors-btn"
                            onClick={() =>
                                navigate(`/company/slot/${slot?.id}`)
                            }
                        >
                            View Investors
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    })
) : (
    <div className="text-center">
        <p>No Records Found</p>
    </div>
)}
        </>
    );
};

export default CompanyMeetings;